import { WIZ_COMMAND_STATE, WizDateUtils, WizMathUtils } from '@wizeoo/akm-core-lib';
import { WizEventManager, WizIcon, WizPopUp, WizRoot} from '@wizeoo/akm-component-lib';
import { Measure, WidgetConfigurationItemObj, WorkCom } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { ViewData } from '../../model/view.data';
import { BaselineEngine, EM_ACTION, FeiKeyDef, FIELD_KIND, FreedataValueVO, WizConstants, WorkComReply, WorkComVO } from '@wizeoo/akm-compute-lib';
import { ICellRendererParams } from 'ag-grid-community';
import { WizColDef } from '../../manager/workingdata/fei.engine';
import { FakeVO } from '../../vo/common/tool/fake.vo';
import { FreedataArgsVO } from '../../vo/core/freedataargs.vo';
import { WorkcomCommitCmd } from '../../command/em/workcomcommit.cmd';
import { WorkcomCheckCmd } from '../../command/em/workcomcheck.cmd';
import { AlkEvent } from '../../framework/events/alk.event';
import { ALK_EVENT_TYPE } from '../../model/enums';
import { WorkflowEngine as BaseWorkflowEngine} from '@wizeoo/akm-compute-lib';
import { FeiVO } from '../../vo/workingdata/fei.vo';


/**
 * gestion des workflows
 */
export class WorkflowEngine extends BaseWorkflowEngine{

  constructor(model: Model) {
      super(model);
  }

  protected get model(): Model {
    return this._model as Model;
  }
  protected set model(value: Model) {
      this._model = value;
  }


  /** création d'un nouveau workcom */
  public buildFake(): WorkComVO {
    
    const result: WorkCom = new WorkCom();
    result.naturalUID = WizMathUtils.createUUID();
    result.domain = this.model.domainCode;
    result.businessUnitCode = this.model.businessUnitCode;
    result.vision = this.model.visionCode ? this.model.visionCode : ViewData.wildcardDomain;
    // alimenter le from sur params
    let params: any = {};
    params.from = this.model.connectedUser.mail;
    result.params = params;

    let vo = new WorkComVO(this.model, result);
    return vo;
  }


  public merge(to: WorkComVO, from: WorkComVO, callback: Function): void {
    if(to.exist) {
      to.operation = EM_ACTION.UPDATE;
    } else {
      to.operation = EM_ACTION.CREATE;
    }
    new WorkcomCommitCmd(this.model).commit(to, this.backFromCall.bind(this), callback).execute();
  }

  /**
   * delete d'un WorkComVO
   * @param to le clone à supprimer
   * @param callback retour dans la vue
   */
  public remove(to: WorkComVO, callback: Function): void {
    to.operation = EM_ACTION.DELETE;
    // const pack: EntityModificationPack = EMEngine.removeEM(to);
    new WorkcomCommitCmd(this.model).commit(to, this.backFromCall.bind(this), callback).execute();
  }

  /** 
   * chargement des modifications: FDV / BL / BLV en one shot sur modif externe (cross / batch / other player)
   * 
   * @param source CompositeSourcePack contient l'ensemble des modifs FD/ FDV / BL / BLV
   */
  public check(): void {
    new WorkcomCheckCmd(this.model).check(this.backFromCall.bind(this))
    .silent(true)  
    .execute();
  }


  /**
   * gestion unifiée des retours de service CUD
   * @param cmd la commande commit qui porte les EMs et les objets
   */
  private backFromCall(cmd: WorkcomCommitCmd): void {
    // modèle OK (rollback en cas d'erreur)
    ViewData.wizUpdateModel = false;

    // erreur physique
    if (cmd.state === WIZ_COMMAND_STATE.FAULT) {
      WizPopUp.toast('$.common.toast.service.error.$', WizIcon.TOAST_ERROR).show();
    } else {

      // synchronisation du cache local & des collections
      this.model.workcomSyncService.eatRemote(cmd.result);
      if(!!cmd.viewCallback) {
        cmd.viewCallback(cmd.result); // retour en vue
      }
      
      WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.REMOTE_MESSAGE_UPDATE, cmd.result));
    }
  }

  /**
   * formattage sur measure ou FD.sub
   */
  public valueFormatter(params: ICellRendererParams): string {
    let result: string = null;
    if(params.value) {
      // prise de la mesure
      let fkd: FeiKeyDef = (params.colDef as WizColDef).fkd;
      let setts: any = null;
      if(fkd.isMeasure) {
        let meas: Measure = fkd.measure;
        setts = meas.settings || null;

        // possible override sur le FKD
        let wcio: WidgetConfigurationItemObj = (params.colDef as WizColDef).wcio;
        if(wcio?.pmdexParams)  { // conversion du params en objet
          setts = this.model.widgetEngine.pmdExParams(wcio);
        }
      } else { // un freedata
        // le param.value est OK

        // prise du args
        let arg: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(fkd.code, (params.colDef as WizColDef).wcio.fdvf);
        if(!!arg) { //prise du settings
          setts = arg.settings || null;
        }    
      }
      
      result = this.formatWorkflow(setts, params.value);
    }
    // console.log('valueFormatter', params.value, result);
    return result;
  }

  public valueFormatterFD(params: ICellRendererParams): string {
    let result: string = null;
    if(params.value) {
      //console.log("params", params);
      // TODO gestion val FDV
      // prise de la mesure
      const field : string = (params.colDef as WizColDef).fdvfield.split(WizConstants.FD_PARTS_SEPARATOR)[0];
      let fdv: FreedataValueVO = params.data;
      let conf: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(fdv.freeDataCode, field);
      let setts: any = conf.settings;
      
      // possible override sur le FKD
      let wcio: WidgetConfigurationItemObj = (params.colDef as WizColDef).wcio;
      if(wcio?.pmdexParams)  { // conversion du params en objet
        setts = this.model.widgetEngine.pmdExParams(wcio);
      }

      try {
        result =  this.formatWorkflow(setts, params.value);
        // console.log('good Wf', setts, params.value);
      } catch(e: any) {
        // console.log('bad Wf', setts, params.value);
      }
      
    }
    return result;
  }


  public formatWorkflow(settings: any, workflowNaturalUID: string): string {
    let result: any = {};  
    // prise du workcom
    let mess: WorkComVO = this.getWorkCom(workflowNaturalUID);
    if(!!mess) {
      // prise des champs
      let fieldArr: string[] = [];
      let fieldSet: Set<string> = new Set();
      [...settings?.fields || []].forEach(element => {
        fieldArr.push(element);
        fieldSet.add(element);
      });

      // pas de settings, on prend juste le commentaire
      if(fieldArr.length === 0) {
        fieldArr.push("comment");
      }

      // prise du bon item selon la conf
      let targetWCR: WorkComReply;
      try {
        let firstWCR: WorkComReply = WorkflowEngine.replyFromWC(mess);
        let allWCR: WorkComReply[];
        if(mess.params?.replies) {
          allWCR = [firstWCR, ...mess.params?.replies];
        } else {
          allWCR = [firstWCR];
        }
        allWCR = allWCR.sort((a,b) => a.idx - b.idx);
        targetWCR = firstWCR;
        if(!!settings?.item) {
          switch(settings.item) {
            case 'first':
              // rien à faire c'est déjà lui
            break;
            case 'last':
              targetWCR = allWCR.pop();
            break;
          }
        } else {
          // rien à faire c'est déjà lui
        }

      }
      catch(e: any) {
        console.log('wtf', mess);
      }
      
      // gestion de l'icone d'état
      if(fieldSet.has('state@icon')) {
        let stateMap: Map<string, FakeVO> = new Map(ViewData.getInstance().workflowState.map(item => [item.code, item]));
        let iconVO: FakeVO = stateMap.get(targetWCR?.state);
        if(!!iconVO) {
          result.icon = iconVO.icon;
        }
      }

      // gestion du média
      if(fieldSet.has('image')) {
        result.image = mess.params?.imgBlob || null;
      }
      
      // gestion file
      if(fieldSet.has('file')) {
        result.media = mess.params?.media || null;
      }

      let keys: string[] = [];
      fieldArr.forEach(f => {
        switch(f) {
          case "object":
            keys.push(mess.obj);
          break;
          case "comment":
            keys.push(targetWCR?.content);
          break;
          case "state":
            let stateMap: Map<string, FakeVO> = new Map(ViewData.getInstance().workflowState.map(item => [item.code, item]));
            let iconVO: FakeVO = stateMap.get(targetWCR?.state);
            if(!!iconVO) {
              keys.push(iconVO.trsLabel);
            }
          break;
          case "to":
            keys.push(mess.params?.to?.join(ViewData.STYLE_ELEMENT_SEPARATOR));
          break;
          case "from":
            keys.push(targetWCR?.who);
          break;
          case "startDate":
            if(targetWCR?.startDate) {
              let format = this.model.formatEngine.getDefaultFormat(FIELD_KIND.DATE);
              let dd =  WizDateUtils.dateToString(WizDateUtils.stringToTime(targetWCR.startDate.toString()), format.dateExp);
              if(dd) {
                keys.push(dd);
                result.startDate = targetWCR.startDate.toString(); // on force pour le rendu timeline
              }
            }
          break;
          case "endDate":
            if(targetWCR?.endDate) {
              let format = this.model.formatEngine.getDefaultFormat(FIELD_KIND.DATE);
              let dd =  WizDateUtils.dateToString(WizDateUtils.stringToTime(targetWCR.endDate.toString()), format.dateExp);
              if(dd) {
                keys.push(dd);
                result.endDate = targetWCR.endDate.toString(); // on force pour le rendu timeline
              }
            }
          break;
        }
      });


      result.keys = keys.filter(item => item?.length > 0);
    }
    
    return JSON.stringify(result);
  }

  public formatForExport(workflowNaturalUID: string): string {
    let result: string[] = [];
    let mess: WorkComVO = this.getWorkCom(workflowNaturalUID);

    if(!mess) {
      return null;
    }


    let stateMap: Map<string, FakeVO> = new Map(ViewData.getInstance().workflowState.map(item => [item.code, item]));
    let iconVO: FakeVO = stateMap.get(mess.params?.state);
    if(!!iconVO) {
      result.push(iconVO.format);
      result.push(iconVO.trsLabel);
    }

    if(mess.obj) {
      result.push(mess.obj);
    }
    if(mess.comment) { // TODO TODO aggréger les exports
      result.push(mess.comment);
    }
    if(!!mess.params?.to) {
      result.push(mess.params.to.join(ViewData.STYLE_ELEMENT_SEPARATOR));
    }
    if(mess.params?.from) {
      result.push(mess.params.from);
    }
    if(mess.params?.startDate) {
      let format = this.model.formatEngine.getDefaultFormat(FIELD_KIND.DATE);
      let dd =  WizDateUtils.dateToString(WizDateUtils.stringToTime(mess.params.startDate.toString()), format.dateExp);
      if(dd) {
        result.push(dd);
      }
    }
    if(mess.params?.endDate) {
      let format = this.model.formatEngine.getDefaultFormat(FIELD_KIND.DATE);
      let dd =  WizDateUtils.dateToString(WizDateUtils.stringToTime(mess.params.startDate.toString()), format.dateExp);
      if(dd) {
        result.push(dd);
      }
    }
    return result.join(' - ');
  }


  /**
   * modification d'un workcom par d'n'd sur un calendar
   * @param props 
   * @param startDate 
   * @param endDate 
   * @param callBack 
   * @returns les props avec le workcom à jour dans la callBack
   */
  public generateUpdateFromCalendar(fei: FeiVO, props: any, startDate: string, endDate: string, callBack: Function):  void {
    
    // TODO si c'est MOI qui possède le WorkcomReply
    
    // extendedProps: {
    //   context: this.context,
    //   title: realLabel,
    //   content: cleanPart.join(' - '),
    //   color: realtextColor,
    //   startFkd: tle.startFkd,
    //   endFkd: tle.endFkd,
    //   freedataValue: null, 
    //   widgetLine: wl,
    //   id: eventId,
    //   ds: this.mainDS,
    //   //contrast: contrast
    // }

    
    let fkd: FeiKeyDef = props.startFkd;
    
    let wcCode: string = BaselineEngine.getRawKeyOrValue(fei, props.widgetLine, fkd.fullCode);
    // console.log('generateUpdateFromCalendar', wcCode);
    if(fkd.datakind === FIELD_KIND.OBJECT) {
      wcCode = this.model.freedataEngine.getSubFDV(wcCode);
    } 
    
 
    let workcom: WorkComVO = this.getWorkCom(wcCode);
    // console.log('generateUpdateFromCalendar workcom', wcCode);
    // TODO wc sur FD si pas mesure ?
    let settings: any = fkd.measure?.settings;


    if(!!workcom && !!settings) {
      let isLast: boolean = settings.item === 'last';
      if(isLast) { // dernier message, c'est peut-être quand même le 1er s'il est seul
       if(workcom.params?.replies?.length > 0) {
        let idx: number = 0;
        let targetReply: WorkComReply = null;
        workcom.params.replies.forEach(wcr => {
          if(wcr.idx > idx) {
            targetReply = wcr;
            idx = wcr.idx;
          }
        });
        if(!!targetReply) {
          targetReply.startDate = Number(startDate);
          targetReply.endDate = Number(endDate);
        }

       } else { // c'est quand même le 1er
         workcom.params.startDate = Number(startDate);
         workcom.params.endDate = Number(endDate);
       }

      } else {
         workcom.params.startDate = Number(startDate);
         workcom.params.endDate = Number(endDate);
      }

      //if (!errors || (!!errors && errors.length === 0)) {
        Model.getInstance().workflowEngine.merge(workcom, workcom, callBack);
      // } else {
      //   WizPopUp.toast('$.common.toast.pending.error.$', WizIcon.TOAST_ERROR).show();
      // }


    } else {
      console.log('oups bad update', props, startDate, endDate);
    }
  }

}
